import { useClickOutside } from "@mantine/hooks";
export default useClickOutside;
